import { ActionIcon, CheckIcon, Combobox, Tooltip, useCombobox } from '@mantine/core';
import { IconColumns3 } from '@tabler/icons-react';
import { type Table } from '@tanstack/react-table';
import clsx from 'clsx';

type DataTableViewOptionsProps<TData> = {
  table: Table<TData>;
};

export default function DataTableViewOptions<TData>({ table }: DataTableViewOptionsProps<TData>) {
  const combobox = useCombobox({});
  const hidableColumns = table.getAllColumns().filter((column) => column.getCanHide());

  return hidableColumns.length > 0 ?
      <Combobox
        store={combobox}
        width={150}
      >
        <Combobox.Target>
          <Tooltip label="View options">
            <ActionIcon
              size="sm"
              variant="light"
              color="gray"
              onClick={() => combobox.toggleDropdown()}
            >
              <IconColumns3 size={16} />
            </ActionIcon>
          </Tooltip>
        </Combobox.Target>

        <Combobox.Dropdown>
          <Combobox.Options>
            {hidableColumns.map((column) => {
              return (
                <Combobox.Option
                  key={column.id}
                  value={column.id}
                  onClick={() => {
                    column.toggleVisibility();
                  }}
                >
                  <div className="flex items-center gap-2">
                    <CheckIcon
                      className={clsx(!column.getIsVisible() && 'opacity-0')}
                      size={12}
                    />
                    {typeof column.columnDef.header === 'string' ? column.columnDef.header : column.id}
                  </div>
                </Combobox.Option>
              );
            })}
          </Combobox.Options>
        </Combobox.Dropdown>
      </Combobox>
    : null;
}
